import LocationList from './LocationList';
import {Provider} from './LocationContext';

export const Locations = () => {
  return (
    <Provider>
      <LocationList />
    </Provider>
  );
};
